export default "__VITE_ASSET__Dui0$6qV__"